import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";


export const decodeToken = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded;
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const IsTokenExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) {
    return true;
  }

  const currentTime = Math.floor(Date.now() / 1000);
  return decoded.exp < currentTime;
};

export const HandleExpiredToken = () => {
  const navigate = useNavigate();
  Cookies.remove("noohraToken");
  navigate("/signup");
};

// Explanation:
// 1. MyTokenPayload interface extends JwtPayload to include custom fields.
// 2. decodeToken function decodes a JWT and returns the payload or null if invalid.
// 3. IsTokenExpired checks if a token has expired based on its 'exp' claim.
// 4. HandleExpiredToken removes the token from cookies and redirects to the login page.
